<template>
  <div id="SOVReport">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap card">
      <div class="leftcontent wrapitem">
        <div class="datebox customSelect">
          <select @change="getReport" v-model="siteType" class="form-control text-uppercase">
            <option value="retail">Retail</option>
            <option value="oem">Consumer OEM</option>
            <option value="commercial">Commercial OEM</option>
          </select>
        </div>
        <div class="datebox customSelect">
          <select @change="getReport" v-model="device" class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
            <option value="desktop">Desktop</option>
          </select>
        </div>

        <div class="datebox customSelect" style="width:18%" v-show="false">
          <select @change="getReport" v-model="rType" class="form-control text-uppercase">
            <option value="category">Category</option>
            <option value="search">Search</option>
          </select>
        </div>
      </div>
    </div>


    <div class="datepickerwrap card">
      <div class="space-between-header">
        <h4 class="m-0 cardHeading"> AMD Sell-out Share</h4>
        <div style="display: flex;">
          <div style="margin-left: 9px;" v-for="(d, i) in legend" :key="i">
            <span class="lbllegend"> {{ i }}: {{ d }} </span>
          </div>
        </div>
      </div>
      <div>
        <div class="custom-hr-scroll">
          <table>
            <thead>
              <tr class="tr1">
                <th v-for="(d, i) in cols" :key="i">
                  <img v-if="d.img" :style="'width:' + d.width" :src="'/img/sov/' + d.img" style="margin: 10px"/>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="tr2" v-for="(d, i) in cols" :key="i">
                  <div v-if="i == 0">Share of Voice</div>
                  <div style="text-align:center" v-else>{{ d.brand }}</div>
                </td>
              </tr>
              <tr class="tr3row" v-for="(row, ri) in data.tdata" :key="ri">
                <td class="tr3" v-for="(d, i) in cols" :key="i">
                  <div style="text-align:left" v-if="d.key == 'title'">
                    <span style="display:inline-block">{{ row[d.key][0] }}</span>
                    <span> {{ row[d.key][1] }} </span>
                  </div>
                  <div v-else>
                    {{ row[d.key] }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="tr4" :colspan="cols.length">Reviews</td>
              </tr>
              <tr style="border: 2px solid var(--background) !important;">
                <td class="tr5" v-for="(d, i) in cols" :key="i">
                  <div style="text-align:center" v-if="d.key != 'title'">
                    <span
                      style="width:50%;display:inline-block;border-right: 2px solid var(--background);background-color: var(--primary_client-80); color: white;">AMD</span>
                    <span style="width:50%;display:inline-block;background-color: var(--primary_competitor-80); color: white;">Intel</span>
                  </div>
                  <div v-else></div>
                </td>
              </tr>
              <tr v-for="(row, ri) in data.trdata" :key="ri">
                <td class="tr6" v-for="(d, i) in cols" :key="i">
                  <div style="text-align:left" v-if="d.key == 'title'">
                    <span style="display:inline-block">{{ row[d.key][0] }} </span>
                    <span> {{ row[d.key][1] }}</span>
                  </div>
                  <div style="text-align:center" v-else>
                    <span style="width:50%;display:inline-block;border-right: 2px solid var(--background);"> {{ row[d.key].amd }}
                    </span>
                    <span style="width:50%;display:inline-block">{{ row[d.key].intel }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody style="border-top:2px solid var(--background);border-bottom:2px solid var(--background)">
              <tr v-for="(row, ri) in data.tr2data" :key="ri">
                <td class="tr7" v-for="(d, i) in cols" :key="i">
                  <div style="text-align:left" v-if="d.key == 'title'"> {{ row[d.key][0] }}</div>
                  <div :title="row[d.key]" class="rvtlong" style="text-align:center" v-else>{{ row[d.key] }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from './Components/Loader.vue';


export default {
  name: 'SOVReport',
  components: { Datepicker, Loader },
  data: function () {
    return {
      loader: false,
      device: 'laptop',
      rType: 'category',
      data: {},
      timeMap: {
        '1 week': '1 week (1st Jan, 21 to 7th Jan, 21)',
        '1 month': '1 month (Jan, 21)',
      },
      cols: [],
      colsRetailers: [
        { brand: '', key: 'title', img: '', width: '69px' },
        { brand: 'Amazon US', key: 'amazon_US', img: 'amazon.png', width: '69px' },
        { brand: 'Best Buy US', key: 'BESTBUY', img: 'bb.png', width: '46px' },
        { brand: 'Costco US', key: 'costco', img: 'costco.png', width: '85px' },
        { brand: 'Walmart US', key: 'walmart', img: 'walmart.png', width: '95px' },
        { brand: "Curry's UK", key: 'currys_uk', img: 'dixon.png', width: '78px' },
        { brand: 'Harvey Norman AU', key: 'harvey', img: 'hn.png', width: '91px' },
        { brand: 'JD GC', key: 'jd', img: 'jd.png', width: '40px' },
        { brand: 'MediaMarkt DE', key: 'mediamarkt', img: 'mediamarkt.png', width: '80px' },
      ],
      colsOEM: [
        { brand: '', key: 'title', img: '', width: '69px' },
        { brand: 'Acer Brazil', key: 'acer_brazil', img: 'acer.png', width: '86px' },
        { brand: 'Acer US', key: 'Acer', img: 'acer.png', width: '86px' },
        { brand: 'ASUS France', key: 'asus_france', img: 'asus.png', width: '94px' },
        { brand: 'ASUS US', key: 'asus', img: 'asus.png', width: '94px' },
        { brand: 'Dell Australia', key: 'dell_australia', img: 'dell.png', width: '49px' },
        { brand: 'Dell Japan', key: 'dell_japan', img: 'dell.png', width: '49px' },
        { brand: 'Dell US', key: 'dell', img: 'dell.png', width: '49px' },
        { brand: 'Dell UK', key: 'dell_uk', img: 'dell.png', width: '49px' },
        { brand: 'Fujitsu Japan', key: 'fujitsu', img: 'fujitsu.png', width: '90px' },
        { brand: 'HP France', key: 'hp_france', img: 'hp.png', width: '49px' },
        { brand: 'HP Japan', key: 'hp_japan', img: 'hp.png', width: '49px' },
        { brand: 'HP Mexico', key: 'hp_mexico', img: 'hp.png', width: '49px' },
        { brand: 'HP UK', key: 'hp_uk', img: 'hp.png', width: '49px' },
        { brand: 'HP US', key: 'hp', img: 'hp.png', width: '49px' },
        { brand: 'Lenovo Australia', key: 'lenovo_australia', img: 'lenovo.png', width: '90px' },
        { brand: 'Lenovo China', key: 'lenovo_gc', img: 'lenovo.png', width: '90px' },
        { brand: 'Lenovo France', key: 'lenovo_france', img: 'lenovo.png', width: '90px' },
        { brand: 'Lenovo Germany', key: 'lenovo_germany', img: 'lenovo.png', width: '90px' },
        { brand: 'Lenovo UK', key: 'lenovo_uk', img: 'lenovo.png', width: '90px' },
        { brand: 'Lenovo US', key: 'lenovo', img: 'lenovo.png', width: '90px' },
        { brand: 'NEC Japan', key: 'nec', img: 'nec.png', width: '90px' },

      ],
      colsComm: [
        { brand: '', key: 'title', img: '', width: '69px' },
        { brand: 'Commercial HP China', key: 'hp_china', img: 'hp.png', width: '49px' },
        { brand: 'Commercial HP France', key: 'hp_france', img: 'hp.png', width: '49px' },
        { brand: 'Commercial HP Germany', key: 'hp_germany', img: 'hp.png', width: '49px' },
        { brand: 'Commercial HP Japan', key: 'hp_uk', img: 'hp.png', width: '49px' },
        { brand: 'Commercial HP UK', key: 'hp_japan', img: 'hp.png', width: '49px' },
        { brand: 'Commercial HP US', key: 'hp', img: 'hp.png', width: '49px' },
        { brand: 'Commercial Lenovo China', key: 'lenovo_china', img: 'lenovo.png', width: '110px' },
        { brand: 'Commercial Lenovo France', key: 'lenovo_france', img: 'lenovo.png', width: '110px' },
        { brand: 'Commercial Lenovo Germany', key: 'lenovo_germany', img: 'lenovo.png', width: '110px' },
        { brand: 'Commercial Lenovo Japan', key: 'lenovo_germany', img: 'lenovo.png', width: '110px' },
        { brand: 'Commercial Lenovo US', key: 'lenovo', img: 'lenovo.png', width: '110px' },
        { brand: 'Bechtle', key: 'bechtle', img: 'bechtle.png', width: '110px' },
        { brand: 'CDW', key: 'cdw', img: 'cdw.png', width: '110px' },
        { brand: 'Inmac', key: 'inmac', img: 'inmac.png', width: '110px' },
        { brand: 'Insight', key: 'insight', img: 'insight.png', width: '110px' },
        { brand: 'PC Connection', key: 'pc_connection', img: 'connection.png', width: '110px' },
        { brand: 'SHI', key: 'shi', img: 'shi.png', width: '110px' },
        { brand: 'Technoworld', key: 'technoworld', img: 'technoworld.png', width: '110px' },
      ],
      legend: {},
      siteType: 'retail'
    }
  },
  mounted() {
    this.cols = this.colsRetailers
    this.getReport()
  },
  methods: {
    getReport() {
      let self = this
      self.loader = true
      // self.data = {}
      let payload = {
        "item_category": self.device,
        "website_type": self.siteType
      }
      if (self.siteType == 'retail')
        payload.result_type = self.rType

      const url = "/api/websites/website_sovreport"
      this.$http.post(url, payload).then(response => {
        if (self.siteType == 'retail')
          self.cols = self.colsRetailers
        else if (self.siteType == 'oem')
          self.cols = self.colsOEM
        else
          self.cols = self.colsComm


        self.data = response.body.data
        self.legend = response.body.legend
        self.loader = false
      }, err => {
        self.loader = false
      });
    }
  }
}

</script>

<style scoped>
#SOVReport {
  font-family: "Poppins", sans-serif !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  padding: 7px 7px;
}
.cardHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important ;
}
.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
/* select  */
select {
  font-family: "Poppins", sans-serif;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}


.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: var(--primary_brand-80);
  border-color: var(--primary_brand-80);
  height: 35px;
  border-radius: 5px;
  font-weight: 600;
}

.btn-outline-secondary {
  height: 35x;
  line-height: 20px;
  color: var(--primary_brand);
  background: var(--primary_brand-10);
  border: 1px solid var(--primary_brand-10);
}

.btn-group {
  background: var(--primary_brand-10);
  border-radius: 5px;
}


td:first-child {
  background-color: var(--secondary_competitor-5);

}

thead {
  background: none;
  font-family: "Poppins", sans-serif !important;
}

td{
  font-family: "Heebo", sans-serif !important;
}

.tr1 {
  text-transform: none;
  font-family: sans-serif;
  font-weight: bolder;
  text-align: left;
}

.tr2 {
  text-transform: none;
  text-align: left;
  border: 1px solid var(--base_color-20) !important;
  padding-inline: 10px;
  padding-block: 20px;
  font-family: "Poppins", sans-serif !important;
  font-weight: 300 !important;
  font-size: 14px;
  color: rgb(78, 78, 78);
  background-color: var(--background) !important;
  letter-spacing: 0.6px !important;
}

/* .tr2:first-child{
  border-top-left-radius: 10px !important;
}
.tr2:last-child{
  border-top-right-radius: 10px !important;
} */

.tr3 {
  border-bottom: none !important;
  border-top: none !important;
  text-transform: none;
  font-family: "Heebo", sans-serif !important;
  font-size: 13px !important;  
  border-inline: 1px solid var(--base_color-20) !important;
  letter-spacing: 0.1px !important;
}
.tr3:first-child{
  padding-left: 10px !important;
}

.tr4 {
  text-transform: none;
  text-align: left;
  padding-inline: 10px;
  padding-block: 20px;
  font-family: "Poppins", sans-serif !important;
  font-weight: 300 !important;
  font-size: 14px;
  color: rgb(78, 78, 78);
  background-color: var(--background) !important;
  letter-spacing: 0.6px !important;
}

.tr4:first-child{
  border: 1px solid var(--base_color-20) !important;
}

.tr5 {
  border: 1px solid var(--base_color-20) !important;
  border-bottom: none !important;
  border-top: none !important;
  text-transform: none;
  font-family: sans-serif;
  font-weight: bolder;
  padding: 0;
  letter-spacing: 0.6px !important;
}

.tr6 {
  border: 1px solid var(--base_color-20) !important;
  border-bottom: none !important;
  border-top: none !important;
  text-transform: none;
  font-family: "Heebo", sans-serif !important;
  font-size: 13px;  
  padding-block: 0px;
  letter-spacing: 0.1px !important;
}
.tr6:first-child{
  padding-left: 10px !important;
}

.tr7 {
  vertical-align: top !important;
  border: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-top: none !important;
  text-transform: none;
  font-family: "Heebo", sans-serif !important;
  font-size: 13px;
  letter-spacing: 0.1px !important;
}
.tr7:first-child{
  padding-left: 10px !important;
  padding-top: 10px !important;
}

thead tr th:first-child,
tbody tr td:first-child {
  width: 11rem;
  min-width: 11rem;
  max-width: 11rem;
}

.rvtlong {
  width: 100%;
  padding: 9px;
}

.tr3row:nth-child(3) {
  border-bottom: 1px solid var(--base_color-20) !important
}

.tr3row:nth-child(5) {
  border-bottom: 1px solid var(--base_color-20) !important
}

.lbllegend {
  background: var(--base_color-60);
  color: white;
  font-size: 14px;
  line-height: 32px;
  padding: 6px 12px;
  border-radius: 4px;
}

.custom-hr-scroll {
  overflow-x: scroll !important;
}

table {
  width: 100% !important
}

table th,
table td {
  width: 150px;
}

.custom-hr-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

.custom-hr-scroll::-webkit-scrollbar {
  height: 10px;
}

.custom-hr-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}
.custom-hr-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>
